import { Flex, useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import BasePage from "../common/BasePage";
import QuestionForm from "../../components/forms/QuestionForm";
import useGetQuestionDetails from "../../hooks/api/question/useGetQuestionDetails";

type Params = {
  quizId: string;
  questionId: string;
};

export default function EditQuestionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { quizId, questionId } = useParams<Params>();
  const {
    data: question,
    isLoading,
    isError,
    refetch: refetchLesson,
  } = useGetQuestionDetails(quizId ?? "", questionId ?? "");

  const onSuccess = useCallback(() => {
    navigate("./../..");
    toast({
      title: t("edit_question_page.question_updated"),
      description: t("edit_question_page.question_updated_message"),
      status: "success",
      isClosable: true,
    });
  }, [navigate, t, toast]);

  const onError = useCallback(() => {
    toast({
      title: t("edit_question_page.question_error"),
      description: t("edit_question_page.question_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage
      title={t("edit_lesson_page.edit_lesson")}
      isLoading={isLoading}
      hasError={isError}
      retry={refetchLesson}
    >
      <Flex gap={16} flexDirection="column">
        <QuestionForm
          quizId={quizId}
          questionId={questionId}
          question={question}
          onSuccess={onSuccess}
          onError={onError}
        />
      </Flex>
    </BasePage>
  );
}
